import { inject } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn, UrlTree } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalRepository } from '@shared/helper/local-repository';
import { CreateQuoteComponent } from '@app/pages/quotes/pages/create-quote/create-quote.component';
import { AlertConfigModel, ConfirmAlertComponent, EConfirmButton } from '@shared/components/confirm-alert/confirm-alert.component';
import { DRAFT_KEY, DraftModel, IQuoteDraftTemp } from '@shared/helper/draft/models/draft.model';


export const quoteGuard: CanDeactivateFn<CreateQuoteComponent> = (component: CreateQuoteComponent):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const dialog: MatDialog = inject(MatDialog);
  const bottomSheet: MatBottomSheet = inject(MatBottomSheet);
  const localRepository: LocalRepository = inject(LocalRepository);

  const dialogInfo: AlertConfigModel = {
    cancelButtonText: 'بله می‌روم',
    confirmButtonText: 'خیر ادامه می‌دهم',
    title: 'می‌خواهید به صفحۀ دیگری بروید؟',
  };

  if (component?.quoteFormGroup?.dirty || component?.quoteFormGroup?.controls['pageNum']?.value! > component?.book?.mySteps?.steps! || !!(component?.imageField?.value)) {
    if (localRepository.IsInMobile) {
      const bottomSheetRef = bottomSheet.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-bottomsheet'
      });

      return bottomSheetRef.afterDismissed().pipe(
        map((action: EConfirmButton) => handleAction(action, component, localRepository))
      );
    } else {
      const dialogRef = dialog.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-dialog'
      });

      return dialogRef.afterClosed().pipe(
        map((action: EConfirmButton) => handleAction(action, component, localRepository))
      );
    }
  }
  return of(true);
};

function handleAction(action: EConfirmButton, component: CreateQuoteComponent, localRepository: LocalRepository): boolean {
  if (action === EConfirmButton.CANCLE) {
    const existData: DraftModel = JSON.parse(localRepository.getLocalItem(DRAFT_KEY)!) || new DraftModel();
    const existDraftQuote = existData?.review?.data?.findIndex(draft => draft.bookId == component.bookId);
    const draftQuote: IQuoteDraftTemp = {
      body: component.bodyField?.value!,
      bookId: component.bookId,
      pageNumber: component.pageNumField?.value!,
      imageSelected: component.quoteType != 'image',
    };

    if (existDraftQuote! >= 0) {
      existData.quote!.data[existDraftQuote!] = draftQuote;
    } else {
      if (!existData.quote) {
        existData.quote = { draftKey: 'quote', data: [] };
      }
      existData.quote.data.push(draftQuote);
    }
    localRepository.setLocalItem(DRAFT_KEY, JSON.stringify(existData));
    return true;
  } else if (action === EConfirmButton.CONFIRM) {
    return false;
  } else {
    return false;
  }
}
